// extracted by mini-css-extract-plugin
export default {"card":"l3-z"};